import React from "react";
import ReactToPrint from "react-to-print";

import history from "./../../utils/history";

import "./completed.scss";

class GiftPackCompleted extends React.Component {
  state = {
    activationNumber: this.props.activationNumber,
    barcode: this.props.barcode,
    imageUrl: this.props.giftPack && this.props.giftPack.giftPacks[0].imageUrl ? this.props.giftPack.giftPacks[0].imageUrl : ""
  };

  componentWillMount() {
    if (!this.state.activationNumber || !this.state.barcode) {
      history.push("/");
      return;
    }
  }

  return = () => {
    history.push("/");
  };

  render() {
    return (
      <div ref={el => (this.summaryRef = el)} className="row justify-content-center">
        <div className="col-xs-12 col-sm-10 col-lg-8 col-xl-6">
          <h2>Gift Pack Activation Completed</h2>
          <hr className="colorgraph" />
          <div className="text-center">
            <p>Your gift pack has been successfully activated.</p>
            <div id="gift-pack-details" className="completed">
              <ul>
                <li>
                  <div className="row">
                    <strong className="col-6 text-right">Activation Number</strong>
                    <span className="col-6 text-left">{this.state.activationNumber}</span>
                  </div>
                </li>
                <li className="mt-2">
                  <div className="row">
                    <strong className="col-6 text-right">Barcode</strong>
                    <span className="col-6 text-left">{this.state.barcode}</span>
                  </div>
                </li>
              </ul>
              <div>{!this.state.imageUrl ? "" : <img src={this.state.imageUrl} className="gift-pack-image" alt="Gift Pack" />}</div>
            </div>
          </div>
          <div className="row justify-content-center">
            <ReactToPrint
              trigger={() => (
                <a href="#" className="btn btn-secondary">
                  Print This Page
                </a>
              )}
              content={() => this.summaryRef}
            />
          </div>
          <div className="row justify-content-center mt-2">
            <button type="button" className="btn btn-secondary" onClick={this.return}>
              Activate Another Gift Pack
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default GiftPackCompleted;



// WEBPACK FOOTER //
// ./src/pages/completed/giftPackCompleted.jsx